<template>
    <div
        class="uik-progress-bars"
        :class="`uik-progress-bars--${size}`"
    >
        <UikProgress
            v-for="(item, index) in data"
            :key="index"
            :type="item.type || type"
            :label-fill="item.labelFill || labelFill"
            :label-size="item.labelSize || size"
            :color="item.color || color"
            :direction="item.direction || direction"
            :steps="item.steps || getSteps"
            v-bind="item"
        />
    </div>
</template>

<script>
export default {
    name: "UikProgressBars",
    props: {
        /**
         * Progress visualization
         */
        type: {
            type: String,
            default: "line",
            validator (value) {
                return [
                    "line",
                    "steps"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Fill color indicator next to label
         */
        labelFill: {
            type: Boolean,
            default: false
        },
        /**
         * Label and spacing size
         */
        size: {
            type: String,
            default: "regular",
            validator (value) {
                return [
                    "small",
                    "regular"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Universal progress color, inherited by label
         */
        color: {
            type: String,
            default: "primary",
            validator (value) {
                return [
                    "primary",
                    "secondary",
                    "success",
                    "warning",
                    "error",
                    "red",
                    "orange",
                    "yellow",
                    "lime",
                    "green",
                    "cyan",
                    "blue",
                    "purple",
                    "pink",
                    "gray"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Direction of progress visualiztion
         */
        direction: {
            type: String,
            default: "right",
            validator (value) {
                return [
                    "left",
                    "right"
                ].indexOf(value) !== -1
            }
        },
        /**
         * Amount of steps in type 'steps'
         */
        steps: {
            type: [String, Number],
            default: 1,
            validator (value) {
                return !isNaN(parseFloat(value))
            }
        },
        /**
         * List of progress bars
         */
        data: {
            type: Array,
            default () { return [] }
        }
    },
    computed: {
        /**
         * Get amount of steps to render
         *
         * @returns {Number}
         */
        getSteps () {
            let steps = parseFloat(this.steps)
            steps = Math.ceil(steps)

            return steps
        }
    }
}
</script>

<style lang="scss">
.uik-progress-bars {
    width: 100%;

    .uik-progress {
        .uik-progress__line {
            .uik-progress__line-label {
                width: 40%;
                max-width: 40%;
                padding-right: 25px;

                .uik-data-label__text {
                    max-width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                & + .uik-progress__progress {
                    margin-left: 0;
                    width: 60%;
                }
            }
        }
    }

    &--regular {
        .uik-progress {
            & + .uik-progress {
                margin-top: 10px;
            }
        }
    }

    &--small {
        .uik-progress {
            & + .uik-progress {
                margin-top: 3px;
            }
        }
    }
}
</style>
